<template>
  <div>
    <vx-card title-color="primary">
      <div class="container">
        <div class="row justify-content-md-center">
          <div>
            <vs-col
              class="kijinput"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
            >
              <profil
                updateImgInput="updateImgInput0"
                class="otdclas"
                :base="base"
                label="Profil"
                :slug="input.slug"
                :url="
                  input.media && input.media.path
                    ? getApp.getUrlForImageOrVideo(input.media.path)
                    : ''
                "
              ></profil>
            </vs-col>
          </div>
          <div>
            <vs-row>
              <vs-col
                class="kijinput"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <vs-input
                  label="Nom"
                  @keyup.enter="submitData"
                  v-model="input.lastname"
                  class="w-full"
                  name="lastname"
                  :danger="!!formErrors.lastname"
                  :danger-text="
                    formErrors.lastname ? formErrors.lastname[0] : ''
                  "
                  v-on:input="resetErrors('lastname')"
                />
              </vs-col>

              <vs-col
                class="kijinput"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <vs-input
                  label="Prénoms"
                  @keyup.enter="submitData"
                  v-model="input.firstname"
                  class="w-full"
                  name="firstname"
                  :danger="!!formErrors.firstname"
                  :danger-text="
                    formErrors.firstname ? formErrors.firstname[0] : ''
                  "
                  v-on:input="resetErrors('firstname')"
                />
              </vs-col>
            </vs-row>

            <vs-row>
              <vs-col
                class="kijinput"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <vs-select
                  class="w-full"
                  autocomplete
                  label="Age"
                  v-model="input.birthday"
                  placeholder="Sélectionner l'âge"
                  :danger="!!formErrors.birthday"
                  :danger-text="
                    formErrors.birthday ? formErrors.birthday[0] : ''
                  "
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in periods"
                  />
                </vs-select>
              </vs-col>

              <vs-col
                class="kijinput"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <vs-input
                  type="email"
                  label="Email"
                  @keyup.enter="submitData"
                  v-model="input.email"
                  class="w-full"
                  name="email"
                  :danger="!!formErrors.email"
                  :danger-text="formErrors.email ? formErrors.email[0] : ''"
                  v-on:input="resetErrors('email')"
                />
              </vs-col>
            </vs-row>

            <vs-row>
              <vs-col
                class="kijinput"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <vs-select
                  class="w-full"
                  autocomplete
                  label="Ancienneté"
                  v-model="input.hired_at"
                  placeholder="Sélectionner l'ancienneté"
                  :danger="!!formErrors.hired_at"
                  :danger-text="
                    formErrors.hired_at ? formErrors.hired_at[0] : ''
                  "
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in periods"
                  />
                </vs-select>
              </vs-col>

              <vs-col
                class="kijinput"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <vs-input
                  label="Téléphone"
                  type="number"
                  @keyup.enter="submitData"
                  v-model="input.phone"
                  class="w-full"
                  name="phone"
                  :danger="!!formErrors.phone"
                  :danger-text="formErrors.phone ? formErrors.phone[0] : ''"
                  v-on:input="resetErrors('phone')"
                />
              </vs-col>
            </vs-row>

            <!-- <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
                <b style="text-align: left;">Chef</b> . . 
                <vs-chip color="success"> {{ input.manager ? 'OUI' : 'NON' }} </vs-chip>
              </vs-col> -->
            <vs-col class="kijinput" vs-type="flex" vs-w="6">
              <small>Canal de notification</small>&nbsp;
              <ul class="centerx">
                <li>
                  <vs-radio
                    v-model="input.channel"
                    vs-name="canal"
                    :vs-value="1"
                    >Email</vs-radio
                  >
                </li>
                <li>
                  <vs-radio
                    v-model="input.channel"
                    vs-name="canal"
                    :vs-value="0"
                    >SMS</vs-radio
                  >
                </li>
              </ul>
            </vs-col>

            <!-- <vs-col class="kijinput" vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              Team . . 
              <vs-chip color="success"> {{ input.team ? input.team.name : '' }} </vs-chip>
            </vs-col>

            <vs-col class="kijinput" vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              Rôle . . 
              <vs-chip color="success"> {{ input.role ? input.role.name : '' }} </vs-chip>
            </vs-col>

            <vs-col class="kijinput" vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              Fonction . . 
              <vs-chip color="success"> {{ input.fonction ? input.fonction.name : '' }} </vs-chip>
            </vs-col> -->
          </div>
        </div>
      </div>

      <vs-divider style="height: 2px" background="primary"></vs-divider>

      <div class="flex flex-wrap items-center">
        <vs-button class="mr-6" @click="submitData"> Modifier </vs-button>
        <vs-button
          class="ml-2"
          color="danger"
          type="border"
          @click="deleteMyAccount()"
        >
          Supprimer mon compte
        </vs-button>
      </div>

      <vs-divider style="height: 2px" background="primary"></vs-divider>
    </vx-card>
  </div>
</template>

<script>
var base_self;
var input_tempon = {
  deleted_at: "",
  id: "",
  slug: "",
  firstname: "", //
  lastname: "", //
  email: "", //
  phone: "",
  birthday: "",
  hired_at: "",
  others: "",
  fonction_id: "",
  media_id: "",
  email_notification: "",
  firstly: "",
  team_id: "",
  manager: false,
  channel: true,
  state: "",
  email_verified_at: "",
  reset_password_token_end_at: "",
  created_at: "", //
  updated_at: "",
  role: {}, //
  fonction: {}, //------------
  media: {},
  team: {}, //------------
};
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import auth from "../../../../helpers/auth";

export default {
  components: {
    VuePerfectScrollbar,
    Datepicker,
  },
  watch: {},
  data() {
    return {
      param44444: "",
      periods: [],
      url: "/users",
      input: {},
      roles: [],
      functions: [],
      teams: [],
      language: "fr",
      languages: lang,
      settings: {
        maxScrollbarLength: 600,
        wheelSpeed: 0.6,
      },
      formErrors: {},
    };
  },
  computed: {
    base() {
      return this;
    },
    getApp() {
      return window.getApp;
    },
  },
  methods: {
    async deleteMyAccount() {
      if (confirm("Souhaitez-vous vraiment supprimer votre compte ?")) {
        try {
          this.$vs.loading();
          let response = await this.$http.post(
            "users/account/request-account-deletion"
          );
          if (response.data) {
            this.$vs.notify({
              title: "Succès",
              text: "Votre demande a été soumise avec succès",
              color: "success",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle",
            });
            auth.logout();
            this.$router.push("/login").catch(() => {});
          }
        } catch (error) {
          this.$vs.notify({
            title: "Erreur",
            text: "Veuillez contacter l'administrateur",
            color: "danger",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
        }
      }
    },
    mountedFounction() {
      base_self.inputInitialize();
      base_self.getTeams();
      base_self.getFunctions();
      base_self.getRoles();
    },
    initInput() {
      base_self.input = JSON.parse(JSON.stringify(input_tempon));
    },
    inputInitialize() {
      window.getApp.item !== ""
        ? ((base_self.input = JSON.parse(JSON.stringify(window.getApp.item))),
          base_self.input.roles.length
            ? (base_self.input.role = base_self.input.roles[0])
            : (base_self.input.role = ""))
        : base_self.initInput();

      base_self.input.channel = base_self.input.email_notification;

      base_self.input = JSON.parse(JSON.stringify(base_self.input));
    },
    getTeams() {
      base_self.$http.get("/teams").then((response) => {
        base_self.teams = response.data.data;
      });
    },
    getFunctions() {
      base_self.$http.get("/functions").then((response) => {
        base_self.functions = response.data.data;
      });
    },
    getRoles() {
      base_self.$http.get("/roles").then((response) => {
        base_self.roles = response.data.data;

        if (window.getApp.item === "") {
          for (var i = 0; i < base_self.roles.length; i++) {
            if (base_self.roles[i].id === 3) {
              base_self.input.role = JSON.parse(
                JSON.stringify(base_self.roles[i])
              );
              break;
            }
          }
        }
      });
    },
    submitData() {
      var input = JSON.parse(JSON.stringify(base_self.input));
      input.fonction =
        input.fonction && input.fonction.id ? input.fonction.id : "";
      input.team = input.team && input.team.id ? input.team.id : "";
      input.role = input.role && input.role.id ? input.role.id : "";
      base_self.$vs.loading();

      if (!window.getApp.item && !input.id) {
        const slug = JSON.parse(localStorage.getItem("userInfo")).slug;
        base_self.$http
          .post(base_self.url, input)
          .then((response) => {
            window.getApp.success(
              "L'utilisateur a été ajouté avec succès.",
              response
            );
            base_self.initInput();
            window.getApp.addOrUpdateItem = false;
            window.getApp.getList();
          })
          .catch((error) => {
            window.getApp.error(error);
          });
      } else {
        base_self.$http
          .put(base_self.url + `/${input.slug}`, input)
          .then((response) => {
            window.getApp.success(
              "L'utilisateur a été modifié avec succès.",
              response
            );
          })
          .catch((error) => {
            base_self.$vs.loading.close();
            this.$vs.notify({
              title: "Erreur",
              text: "Veuilliez valider les champs du formulaire",
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle",
            });
            if (error.response.data.status_code === 422) {
              this.formErrors = error.response.data.errors;
            }
          });
      }
    },
    resetErrors(field) {
      if (field) {
        this.formErrors[field] = null;
      } else {
        this.formErrors = [];
        Object.keys(this.input).forEach((index) => (this.input[index] = null));
      }
    },
    getCurrentUser() {
      base_self.$vs.loading();
      return base_self.$http
        .post("/auth/me")
        .then((response) => {
          window.getApp.item = response.data.user;
          base_self.$vs.loading.close();
        })
        .catch((error) => {
          window.getApp.error(error);
        });
    },
  },
  async created() {
    base_self = this;
    // await base_self.getCurrentUser();
  },
  async mounted() {
    for (let i = 1; i < 101; i++) {
      this.periods.push(i);
    }
    await base_self.getCurrentUser();
    window.getApp.ajoutComponent = base_self;
    base_self.mountedFounction();
  },
};
</script>

<style>
.kijinput {
  padding: 5px;
  /* padding-left: 15px; */
}
.kijinput {
  padding: 5px;
  /* padding-right: 15px; */
}
.otdclas {
  height: 300px;
  width: 300px;
}

ul li {
  display: inline;
}
</style>